// import global API
import Api from '../../api/Api'

const category = {
    // set namespace true
    namespaced: true,

    // state
    state: {
        // index categories
        categories: [],

        // detail category
        category: {},

        // campaign category
        campaignCategory: []
    },

    // mutations
    mutations: {
        // set state categories dengan data dari response 
        SET_CATEGORIES(state, data) {
            state.categories = data
        },

        // set state category dengan data dari response 
        DETAIL_CATEGORY(state, data) {
            state.category = data
        },

        // set state campaignCategory dengan data dari response 
        CAMPAIGN_CATEGORY(state, data) {
            state.campaignCategory = data
        },
    },

    // actions
    actions: {
        // action getCategoryHome
        getCategoryHome({ commit }) {
            Api.get('/categoryHome')
            .then(response => {
                commit('SET_CATEGORIES', response.data.data)
            }).catch(error => {
                console.log(error)
            })
        },

        // action getCategory
        getCategory({ commit }) {
            Api.get('/categories')
            .then(response => {
                // Sesuaikan path response data sesuai dengan API kamu
                commit('SET_CATEGORIES', response.data.data.data)
            }).catch(error => {
                console.log(error)
            })
        },

        // action getDetailCategory (Sesuai perbaikan)
        getDetailCategory({ commit }, slug) {
            Api.get(`/categories/${slug}`)
            .then(response => {
                // Pastikan struktur response.data.data benar
                // Biasanya detail kategori ada di response.data.data
                commit('DETAIL_CATEGORY', response.data.data)

                // Campaign yang terkait biasanya berada di dalam object kategori tersebut
                // Kita ambil dari response.data.data.campaigns
                commit('CAMPAIGN_CATEGORY', response.data.data.campaigns)
                
            }).catch(error => {
                console.log(error)
            })
        },
    },

    // getters
    getters: {}
}

export default category